<template>
    <ActAsBanner v-if="!isLoginPage" />
    <MainNavbar v-if="!isLoginPage && !$route.meta.bare" />
    <router-view />
    <div v-if="updateAvailable" class="update-notification text-bg-success">
      {{ $t('app.updateAvailable') }} <button class="btn btn-sm btn-success" @click="refreshApp">{{ $t('app.update') }}</button>
      <button type="button" class="btn-close btn-close-white update-notification-close" :aria-label="$t('common.close')" @click="dismissUpdate"></button>
    </div>
    <global-alert ref="globalAlert"></global-alert>
</template>

<script>
import MainNavbar from '@/components/MainNavbar.vue';
import ActAsBanner from '@/components/ActAsBanner.vue';
import { ref, onMounted } from 'vue';

export default {
    name: 'ForusTech',
    components: {
        MainNavbar,
        ActAsBanner
    },
    computed: {
        isLoginPage() {
            return this.$route.name === 'login';
        }
    },
    setup() {
    const updateAvailable = ref(false);

    onMounted(() => {
      window.addEventListener('swUpdated', () => {
        updateAvailable.value = true;
      });
    });

    const dismissUpdate = () => {
      updateAvailable.value = false;
    };

    const refreshApp = () => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    };

    return {
      updateAvailable,
      refreshApp,
      dismissUpdate
    };
  }
};
</script>
<style>
.update-notification {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 40px 10px 10px;
  text-align: center;
  z-index: 1000;
}

.update-notification-close {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
</style>